import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LegacySocialPublishId = Brand<
    number,
    'LegacySocialPublishId'
>;
export const LegacySocialPublishId =
    createBranded<LegacySocialPublishId>();
